import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import { useAppSelector } from '@/redux/hooks';
import { getUrlFromPathname } from '@/redux/modules/config';
import { track } from '@/utils/amplitude/analytics/core';
import { TrackingEvents, TrackingPayload } from '@/utils/amplitude/analytics/core.types';
import { getAmplitudePageNameFromPath } from '@/utils/getPageNameFromPath';

import { LotRecommendationType } from './trackLotRecommendationClicked.analytics';

export type LotRecommendationSeenPayload = TrackingPayload & {
    recommendationIds: number[];
    recommendationName: LotRecommendationType;
};

export const trackLotRecommendationSeenAnalytics = (payload: LotRecommendationSeenPayload) => {
    track(TrackingEvents.Item.LotRecommendationSeen, payload);
};

export const useTrackLotRecommendationSeen = () => {
    const { pathname } = useLocation();
    const url = useAppSelector((state) => getUrlFromPathname(state, pathname));

    return useCallback(
        ({ recommendationIds, recommendationName }: Omit<LotRecommendationSeenPayload, 'pageName' | 'url'>) => {
            trackLotRecommendationSeenAnalytics({
                recommendationIds: recommendationIds,
                recommendationName: recommendationName,
                pageName: getAmplitudePageNameFromPath(pathname),
                url,
            });
        },
        [pathname, url]
    );
};
